import { History } from "history";
import { TableRowProps } from "../../molecules/TableRow/TableRowAtom";
import { pushPathWithSearch } from "../../utilities/pushPathWithSearch";
import {
  createCellWithChildren,
  createInfoCell,
} from "../../utilities/CreateCell";
import { createRow } from "../../utilities/CreateRow";
import { formatLocalDate } from "../../utilities/DataMatrixParser/formatTime";
import { OFFLINE_DEVICE_APPROVAL_PENDING_LABEL } from "./constants";
import {
  notificationButtonStyle,
  notificationLinkStyle,
} from "./CreateNotificationsTable.styles";

export interface NotificationData {
  id: string;
  returnRequestTargetId: string;
  pharmacyTargetId: string;
  userTargetId: string;
  notificationDate: string;
  notificationType: string;
  detailMessage?: string;
  triggeringUserId: {
    username: string;
  };
  creatorUserId: {
    username: string;
  };
}
export interface CreateNotificationsRowsOptions {
  history: History;
  onOfflineDeviceDetailClick?: (entry: NotificationData) => void;
}

export const createNotificationsRows = (
  data: Array<NotificationData>,
  options: CreateNotificationsRowsOptions
) => {
  const rows: Array<TableRowProps> = [];
  data.forEach((entry: NotificationData) => {
    const row: TableRowProps = createRow(
      createNumberCell(entry),
      createCreatedAtCell(entry),
      createNotificationTypeCell(entry, options),
      createUserCell(entry),
      createCreatorCell(entry)
    );
    rows.push(row);
  });
  return rows;
};

const capitalize = (str: string): string => {
    return str?.charAt(0).toUpperCase() + str?.slice(1);
}

const createNumberCell = (entry: NotificationData) => {
  return createInfoCell(entry.id);
};

const createCreatedAtCell = (entry: NotificationData) => {
  return createInfoCell(formatLocalDate(entry.notificationDate));
};

const createNotificationTypeCell = (entry: NotificationData, options: CreateNotificationsRowsOptions) => {
 const returnRequestID = entry.returnRequestTargetId;
  const pharmacyID = entry.pharmacyTargetId;
  const userID = entry.userTargetId;

  let path = "";
  const hasRequestIds = returnRequestID || pharmacyID;

  switch (entry.notificationType) {
    case "New Return Request Created":
      if (hasRequestIds) {
        path = `/admin/pharmacies/${pharmacyID}/returnrequests/${returnRequestID}/items`;
      }
      break;
    case "Note Update":
       if (hasRequestIds) {
        path = `/admin/pharmacies/${pharmacyID}/returnrequests/${returnRequestID}/items?openNote=true`;
      }
      break;
    case "New Pharmacy Created":
      if (hasRequestIds) {
        path = `/admin/pharmacies/${pharmacyID}`;
      }
      break;
    case "New User Created":
      if (hasRequestIds) {
       path = `/admin/${userID}/pharmacy/management`;
      }
      break;
    case OFFLINE_DEVICE_APPROVAL_PENDING_LABEL:
      if (options.onOfflineDeviceDetailClick) {
        return createCellWithChildren(
          <button
            type="button"
            onClick={() => {
              options.onOfflineDeviceDetailClick!(entry);
            }}
            style={notificationButtonStyle}
          >
            {entry.notificationType}
          </button>
        );
      }
      return createInfoCell(entry.notificationType);
    default:
      return createInfoCell(capitalize(entry.triggeringUserId.username));
  }

  if (!path) {
      return createInfoCell(entry.notificationType);
  }

  return createCellWithChildren(
  <a
    href={path}
    style={notificationLinkStyle}
    onClick={(event) => {
      if (
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        event.button !== 0
      ) {
        return;
      }
      event.preventDefault();
      pushPathWithSearch(options.history, path);
    }}
  >
    {entry.notificationType}
  </a>
);
};

const createUserCell = (entry: NotificationData) => {
   return createInfoCell(capitalize(entry.triggeringUserId.username));
};

  const createCreatorCell = (entry: NotificationData) => {
    const username =
      entry.creatorUserId?.username ||
      (entry.notificationType === OFFLINE_DEVICE_APPROVAL_PENDING_LABEL
        ? entry.triggeringUserId?.username
        : undefined);
    return createInfoCell(username ? capitalize(username) : '-');
  };